import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/SiteManagement/pending/ShipyardEvaluationOfShipyardPerformance'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'Shipyard evaluation of shipyard performance'}
        >
            <Component 
            />
        </Layout>
    )
}

export default BlockInspectionStatusMasterlist